import Vue from 'vue'
import GeneralMessage from '@/components/GeneralMessage'
import SvgPlugin from '@/../svg'
import VueI18n from 'vue-i18n'

export default function(dom, opts) {
	let options = {
		...opts
	}

	//plugins
	Vue.use(SvgPlugin)
	Vue.use(VueI18n)

	let cart = new Vue({
		el: dom,
		render(h, context) {
			return h(GeneralMessage, {props: options})
		}
	})

}